module.exports = __webpack_public_path__ + "img/parlement-fr.08b4d51d.png";